export default "__VITE_ASSET__f101a21a__"